import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import CustomBtn from '../../generic/CustomBtn';
import StartOfRegistration from './components/StartOfRegistration';
import ProjectTypeSelect from './components/ProjectTypeSelect';
import TwoProjectPathways from './components/TwoProjectPathways';
import OneProjectPathways from './components/OneProjectPathways';
import { ContextForm } from '../../utils/projectRegistration';
import { AGROFORESTRY_TYPE, REFORESTATION_TYPE } from '../../constans/constans';

const ProjectRegisterPage = () => {
  const history = useHistory();
  const translate = useIntl();
  const { formData } = useContext(ContextForm);
  const [carbonAvailableTypes] = useState([REFORESTATION_TYPE, AGROFORESTRY_TYPE]);

  const launchStep = carbonAvailableTypes.includes(formData.projectType)
    ? <TwoProjectPathways key="TwoProjectPathways" />
    : <OneProjectPathways key="OneProjectPathways" />;

  const steps = [
    <StartOfRegistration key="StartOfRegistration" />,
    <ProjectTypeSelect key="ProjectTypeSelect" />,
    launchStep,
  ];

  return (
    <div className="project-register__wrapper">
      <div className="project-register__cancelBtnPosition">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-cancel' })}
          customClass="btn__close"
          iconClass="icon-close"
          handleClick={() => {
            history.push('/');
          }}
        />
      </div>
      {steps[formData.activeProjectStep]}
    </div>
  );
};

export default ProjectRegisterPage;
